import React, { useEffect, useState } from 'react';
import { BlockStack, Banner, Modal, ResourceItem, ResourceList, Spinner, Text, TextField } from '@shopify/polaris';
import { useDebounced } from '../ItAssets/common';
import { cacApi } from './apiClient';

// "Choose another category…": a debounced search of the full Shopify taxonomy; picking one calls onPick({ id, name }).
export default function CategoryPicker({ onPick, onClose }) {
  const [q, setQ] = useState('');
  const dq = useDebounced(q);
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (dq.trim().length < 2) { setHits([]); setError(''); return undefined; }
    let on = true;
    setLoading(true); setError('');
    cacApi.searchTaxonomy(dq.trim()).then((r) => { if (on) { setHits(r); setLoading(false); } })
      .catch((e) => { if (on) { setError(e.message); setLoading(false); } });
    return () => { on = false; };
  }, [dq]);
  return (
    <Modal open onClose={onClose} title="Choose a category" secondaryActions={[{ content: 'Close', onAction: onClose }]}>
      <Modal.Section>
        <BlockStack gap="300">
          <TextField label="Search" labelHidden value={q} onChange={setQ} autoComplete="off" autoFocus clearButton onClearButtonClick={() => setQ('')}
            placeholder="Search the Shopify taxonomy… e.g. goalkeeper gloves" />
          {error && <Banner tone="critical"><p>{error}</p></Banner>}
          {loading && <Spinner size="small" accessibilityLabel="Searching" />}
          {!loading && dq.trim().length >= 2 && !error && hits.length === 0 && <Text as="p" tone="subdued">No category matches.</Text>}
          {hits.length > 0 && (
            <ResourceList resourceName={{ singular: 'category', plural: 'categories' }} items={hits}
              renderItem={(h) => (
                <ResourceItem id={h.id} onClick={() => onPick(h)} accessibilityLabel={`Use ${h.name}`}>
                  <Text as="span">{h.name.split(' > ').join(' › ')}</Text>
                </ResourceItem>
              )} />
          )}
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
